
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["inOrder_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M341.333 170.667h341.334V128H341.333v42.667zm-42.666-42.71c0-23.552 19.157-42.624 42.453-42.624h341.76c23.424 0 42.453 19.158 42.453 42.624v42.752a42.645 42.645 0 01-42.453 42.624H341.12c-23.424 0-42.453-19.157-42.453-42.624v-42.752zM512 746.667C382.4 746.667 277.333 641.6 277.333 512S382.4 277.333 512 277.333 746.667 382.4 746.667 512 641.6 746.667 512 746.667zM512 704a192 192 0 100-384 192 192 0 000 384zm21.333-320v115.925l96.299 57.792a21.333 21.333 0 01-21.93 36.566l-106.667-64A21.333 21.333 0 01490.667 512V384a21.333 21.333 0 0142.666 0zM236.16 128v42.667s-65.493.021-65.493.106V896s682.666.043 682.666-.107c0 0 0-725.226-.128-725.226H789.91V128h63.296C876.843 128 896 147.072 896 170.773v725.12c0 23.616-18.987 42.774-42.667 42.774H170.667A42.667 42.667 0 01128 895.893v-725.12C128 147.157 147.115 128 170.752 128h65.408z"}})])
          )
        }
      }
    